module.exports = __webpack_public_path__ + "static/media/img-placeholder.84f8adfe.svg";